/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar, Divider, FormControlLabel, Checkbox } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import {debounce} from "lodash";
import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import AutoForm from "../form/functional/AutoForm";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import layoutConf from "../../config/layoutConf";
import TkDeliveryAvailableOrderBuyerDetail from "../screens/TkDeliveryAvailableOrderBuyerDetail";
import defineConf from "../../config/defineConf";


const useStyles = makeStyles((theme) => ({

    keepOpenSwitch: {
        marginLeft: "8px"
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text
    },

}));

function TkDeliveryDetailDialog ( props ) {

    const { t } = useTranslation ();
    const  classes = useStyles ();
    const [instance, setInstance] = useState ();
    const [formData, setFormData] = useState({});

    const [disabled, setDisabled] = useState ( false );
    const [keepOpen, setKeepOpen] = useState(true);

    const [orderBuyerGrid, setOrderBuyerGrid] = useState();
    const [orderBuyerDetailGrid, setOrderBuyerDetailGrid] = useState();

    const [orderBuyerSelect, setOrderBuyerSelect] = useState();
    const [orderBuyerDetailSelect, setOrderBuyerDetailSelect] = useState();

    const [mstApi, setMstApi] = useState();
    const [detailApi, setDetailApi] = useState();

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const {
        
        id,
        schema,
        moveable,
        resizable,
        fullWidth,
        maxWidth,
        
        initialData,
        
        onClose,
        onInitialized,
        onSuccess,
        onSelectMst,
        
        ...others
        
    } = props;

    useEffect(() => {

        (async () => {
            
          if (orderBuyerGrid) {
              
            orderBuyerGrid.selectionChanged.addHandler(debounce((grid, event) => {

                if(grid.selectedItems && grid.selectedItems[0]) {

                    setOrderBuyerSelect(grid.selectedItems[0]);

                } else {

                    setOrderBuyerSelect([]);
                }

            }), 10);
                
            orderBuyerGrid.itemsSourceChanged.addHandler(debounce((grid, event) => {
                
                if(grid.selectedItems && grid.selectedItems[0]) {

                    setOrderBuyerSelect(grid.selectedItems[0]);

                }else {

                    setOrderBuyerSelect([]);
                }

            }), 10);

          }
    
        })();

      }, [orderBuyerGrid]);

    useEffect(() => {

        (async () => {
            
          if (orderBuyerDetailGrid) {
              
            orderBuyerDetailGrid.selectionChanged.addHandler(debounce((grid, event) => {

                if(grid.selectedItems && grid.selectedItems[0]) {

                    setOrderBuyerDetailSelect(grid.selectedItems[0]);

                } else {

                    setOrderBuyerDetailSelect([]);
                }

            }), 10);
                
            orderBuyerDetailGrid.itemsSourceChanged.addHandler(debounce((grid, event) => {
                
                if(grid.selectedItems && grid.selectedItems[0]) {

                    setOrderBuyerDetailSelect(grid.selectedItems[0]);

                }else {

                    setOrderBuyerDetailSelect([]);
                }

            }), 10);

            orderBuyerDetailGrid.loadedRows.addHandler(debounce((flex, event) => {

                for (let row of flex.rows ) {

                    if(Number(row.dataItem.delivered === defineConf.deliveryDetailState.COMPLETE_DELIVERY)) {

                        row.cssClass = `not-regist-materialByCompany`;
                    }

                }

                
            }), 10);

          }
    
        })();

      }, [orderBuyerDetailGrid]);

      useEffect(()=>{

        if(orderBuyerDetailSelect) {

            if(parseInt(orderBuyerDetailSelect?.stockQty)) {

                setDisabled(false);
            }

        } else {

            setDisabled(true);
        }

      },[orderBuyerDetailSelect])

      useEffect(()=> {
        
        setFormData((formData)=> {

            let newFormData = {

                ...formData,
                materialName : orderBuyerDetailSelect?.materialName,
                partNo : orderBuyerDetailSelect?.partNo,
                partSeq : orderBuyerDetailSelect?.partSeq,
                opCode : orderBuyerDetailSelect?.opCode,
                cutCode1 : orderBuyerDetailSelect?.cutCode1,
                cutCode2 : orderBuyerDetailSelect?.cutCode2,
                itemSpecName : orderBuyerDetailSelect?.itemSpecName,
                material : orderBuyerDetailSelect?.material,
                itemUnitName : orderBuyerDetailSelect?.itemUnitName,
                orderBuyerDetailId : orderBuyerDetailSelect?.orderBuyerDetailId,
                qty : orderBuyerDetailSelect?.qty,
                deliveryCompanyName : onSelectMst?.deliveryCompanyName,
                deliveryPlace : onSelectMst?.deliveryPlace,
                shipmentId : onSelectMst?.shipmentId,
                workOrderNumber : orderBuyerSelect?.workOrderNumber,
                dueDate : orderBuyerSelect?.dueDate,
                modelName : orderBuyerSelect?.modelName,
                modelPartName : orderBuyerSelect?.modelPartName,

            };

            return newFormData;

        });

      },[orderBuyerDetailSelect, onSelectMst, orderBuyerSelect]);

    

    const checkItemValidataion = ( schema, formData ,orderBuyerDetailSelect ) => {

        for ( const column of schema.columns ) {

            let [valid, msg] = checkValidation ( "create", column, column.validation, formData[column.name] || "" );

            if ( !valid ) {

                nofifyWarning ( msg );
                return false;

            }

            if(orderBuyerDetailSelect.qty > orderBuyerDetailSelect.stockQty) {
                
                nofifyWarning ( t ("error.outOfStock") );

                return;
            }

            
        }

        return true;

    }
    const nofifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const notifyFailure = (msg) => {
        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onNotifySuccess = ( msg ) => {

        notifySuccess ( msg );

    };

    const onApiSuccess = (result) => {

        setKeepOpen ( ( keepOpen ) => {

            if ( !keepOpen ) {

                instance.hide();

            }

            if  ( onSuccess ) {

                setTimeout ( ( ) =>  onSuccess ( result.data ), 0 );

                if(mstApi && detailApi) {

                    if(orderBuyerDetailGrid.rows.length === 1) {

                        mstApi.refresh();

                    } else {

                        detailApi.refresh();
                    }
                }
            } else {

                onNotifySuccess ( result.data );

            }

            return keepOpen;

        } );

    };

    const onApiFailure = (reason) => {
        
        notifyFailure ( t ( "error.insertFailure", { reason: reason.response ? reason.response.data : JSON.stringify ( reason ) } ) );

    };

    const onOk = ( schema, formData, orderBuyerDetailSelect) => {

        if ( ! checkItemValidataion ( schema, formData , orderBuyerDetailSelect) ) {

            console.error ( "Form Validation Failed" );

            return;

        }

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(

                formData,
                schema.validation

            );

            if (!valid) {

                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }

        }

        // build base api url

        let url = `/api/MomSysShipmentDetail/${formData.shipmentId}`;

        let apiData = { ...formData };
        let form = new FormData ();

        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            if ( schema.columnMap && schema.columnMap[formItem] && schema.columnMap[formItem].formItemType === "file" ) {

                deleted[formItem] = apiData[formItem].deletedFiles;
                    
                for ( const file of apiData[formItem].activeFiles ) {

                    if ( file.type === "url" ) continue;

                    form.append ( formItem, file.file );

                }

            } else {

                if ( apiData[formItem] !== undefined ) {

                    json[formItem] = apiData[formItem];

                }

            }

        }

        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );

        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));

    }

    const onCancel = () => {

        instance.hide();

    };

    const onChange = ( formData ) => {

        setFormData ( formData );

    }

    const onGridInitialized = ( grid ) => {

        grid.selectionMode = "Row";

        setOrderBuyerGrid(grid);

    };

    const onMstApiInitialized = (api) => {

        setMstApi(api);
    }
    const onDetailApiInitialized = (api) => {

        setDetailApi(api);
    }

    const onCloseNotification = () => {

        setNotification( ( notification ) => {

            return ({...notification, open: false});

        } );

    };

    const onCloseDialog = () => {

        if ( onClose ) {

            onClose ();

        }
        
        setFormData(null);
    }

    const onLoadData = ( data ) => {

        setDisabled(data.length < 1 ? true : false);

    }

    const onDetailInitialized = (grid) => {

        setOrderBuyerDetailGrid(grid)

    };

    const checkKeepOpen = () => {

        return (
            <>

                <FormControlLabel
                    control={

                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={ ()=> setKeepOpen( ( keepOpen ) => ( !keepOpen ) ) }
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{flexGrow: 1}}></div>

            </>

        )

    }
    
    return (

        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="lg"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeaderWithClose>
                <DialogTitle>
                    { t ( "dialog.title.MomSysDeliveryDetail.create" ) }
                </DialogTitle>
            </DialogHeaderWithClose>

            <Divider />

            <DialogContent style={{padding: "0px", height: "600px"}}>

                <ReflexContainer orientation="vertical">

                    <ReflexElement flex={0.65}>

                        <ReflexContainer orientation="horizontal">

                            <ReflexElement flex={0.5} >

                                <BasicCrudScreenType
                                    id={"TkVwDeliveryAvailableOrderBuyer"}
                                    embededInOtherScreenType
                                    headerTitle={t("term.so")}
                                    view={"TkVwDeliveryAvailableOrderBuyer"}
                                    noExcel
                                    onInitialized={onGridInitialized}
                                    onApiInitialized = {onMstApiInitialized}
                                    onModifyViewUrl = {(url) => `${url}/${onSelectMst.clientCompanyCode}/${onSelectMst.deliveryCompanyCode}`}
                                    onLoadData={onLoadData}

                                />

                            </ReflexElement>
                    
                        <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                    <ReflexElement flex={0.5}>

                        {
                            orderBuyerSelect ?

                            <TkDeliveryAvailableOrderBuyerDetail
                                onSelect = {orderBuyerSelect}
                                onDetailInitialized = {onDetailInitialized}
                                onDetailApiInitialized = {onDetailApiInitialized}
                                onLoadData={onLoadData}
                            />
                            :
                            <></>
                        }

                    </ReflexElement>

                </ReflexContainer>

                </ReflexElement>

                <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }}/>

                <ReflexElement flex={0.35}>

                    <div
                        style={{
                            padding: "16px"
                        }}                    
                    >

                        <AutoForm
                            id="ship-form"
                            schema={schema}
                            mode="edit"
                            initialData={formData}
                            onChange={onChange}
                        />

                    </div>

                    </ReflexElement>

                </ReflexContainer>

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                firstActionComponent={checkKeepOpen}
                labels={[ t("common.add")]}
                buttonDisabled={[disabled, false]}
                onOk={() => onOk(schema, formData, orderBuyerDetailSelect)}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default TkDeliveryDetailDialog;
